(function(b){function c(){}for(var d="assert,count,debug,dir,dirxml,error,exception,group,groupCollapsed,groupEnd,info,log,timeStamp,profile,profileEnd,time,timeEnd,trace,warn".split(","),a;a=d.pop();){b[a]=b[a]||c}})((function(){try
{console.log();return window.console;}catch(err){return window.console={};}})());

var formatMoney = "$ \{\{amount\}\}";

var isMobile = {
    Android: function() {
        return navigator.userAgent.toLowerCase().match(/android/i);
    },
    BlackBerry: function() {
        return navigator.userAgent.toLowerCase().match(/blackberry/i);
    },
    iOS: function() {
        return navigator.userAgent.toLowerCase().match(/iphone|ipad|ipod/i);
    },
    Opera: function() {
        return navigator.userAgent.toLowerCase().match(/opera mini/i);
    },
    Windows: function() {
        return navigator.userAgent.toLowerCase().match(/iemobile/i);
    },
    any: function() {
        return (isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows());
    }
};

var fancyboxSettings = {
  hideOnContentClick: true,
  titleShow : true,
  padding : 0,
  margin:[40,52,40,52],
  nextEffect: 'fade',
  prevEffect: 'fade',
  closeEffect : 'fade',
  autoCenter: true,
  helpers: {
    overlay: {speedOut : 500, locked: true}
  },
  afterLoad: function() {
  	//$('html').addClass('fancybox-lock');
  },
  afterShow: function() {
    setTimeout(function(){
    	$.fancybox.update();
    }, 200);
  }
};
jQuery(function($) {

  function applyHeaderOffset() {
    if ($(window).width() > 749) {
      $('.content-wrapper').css('padding-top', $('#header').outerHeight());
    } else {
      $('.content-wrapper').css('padding-top', 0);
    }
  }

  $(window).on('load resize orientationchange', applyHeaderOffset);

});


  	if(!isMobile.any()) {
      $('body').addClass('isNotMobile'); 
    }

  	$(document).on("click", ".quantity .minus", function() {
      	var wrapper = $(this).parent();
    	try {
          wrapper.find('input[type=number]').get(0).stepDown();
          wrapper.find('input[type=number]').change();
        } catch(e) {
          var value = (parseInt(wrapper.find('input[type=number]').val())-1);
          wrapper.find('input[type=number]').val((value>=1 ? value : 1));
          wrapper.find('input[type=number]').change();
        }
  	});
  	$(document).on("click", ".quantity .plus", function() {
      	var wrapper = $(this).parent();
    	try {
          wrapper.find('input[type=number]').get(0).stepUp();
          wrapper.find('input[type=number]').change();
        } catch(e) {
          var value = (parseInt(wrapper.find('input[type=number]').val())+1);
          wrapper.find('input[type=number]').val(value);
          wrapper.find('input[type=number]').change();
        }
  	});

  	if($('#side-cart').length > 0) {
    	initSideCart();
  	}

  	
  		$('body').delegate('.add-to-cart-form', 'submit', function(){
            if(validateAddCart($(this))) {
              addToCart($(this));
            }
            return false;
        });
  	
  	
  	$(window).scroll(function(){
        if($(this).scrollTop()<=200) {
          $('.scrollup').fadeOut();
        } else {
          $('.scrollup').fadeIn();
        }
     
      
      	if( $(this).scrollTop()>=80 ) {
          	$('.header-drop').addClass('scroll');
        } else {
        	$('.header-drop').removeClass('scroll');
        }
      
      
      	if( $(this).scrollTop()>=30 ) {
          	$('#top-header').addClass('scroll');
        } else {
        	$('#top-header').removeClass('scroll');
        }
    });
  
  $(window).resize(function(){
  if ($.fancybox && typeof $.fancybox.update === 'function') {
    $.fancybox.update();
  }
});

	

  	$("a[rel='fancybox']").fancybox(fancyboxSettings);
  	var confSizeguide = {};
  	$.extend(confSizeguide, fancyboxSettings, {
      maxWidth    : '100%',
      fitToView   : false,
      width       : '100%',
      height      : 'auto',
      autoSize    : false,
      autoCenter: false
    });
    
    //$(document).on("click", "a[rel='sizeguide']", function(event){
      //event.preventDefault();
      //$.fancybox.close();
      $("a[rel='sizeguide']").fancybox(confSizeguide);
      //return false;
    //});
    
  	$("a[rel='fancybox']").fancybox(fancyboxSettings);
  	var confGuarantee = {};
  	$.extend(confGuarantee, fancyboxSettings, {
      maxWidth    : '100%',
      fitToView   : false,
      width       : '600px',
      height      : 'auto',
      autoSize    : false,
      autoCenter: true
    });
 
      $("a[rel='guarantee_content']").fancybox(confGuarantee);
 
    
    
  	$('#footer .mailing-list form').submit(function(e){
    	e.preventDefault();
      	e.stopImmediatePropagation();

      	var form = $(this);
      	$.ajax({
          	url: form.attr('action'),
          	data: form.serialize(),
          	type: 'POST'
        }).done(function(){
            $('#footer .mailing-list form').fadeOut(function(){
            	$('#footer .mailing-list .success').fadeIn();
            });
        });
    });
  
  $(".scrollTo").on("click", function(event){
    event.preventDefault();
    var scrollTo;
    if($(this).attr('href') != "#"){
      scrollTo = $($(this).attr('href')).offset().top - $(".header-drop").height() - 20;
    }else{
      scrollTo = 0;
    }
    $("html, body").animate({ 
      scrollTop: scrollTo
    }, 1000);
  });


function validateEmail(email) {
    var re = /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i;
    return re.test(email);
}

function validateAddCart(form) {
  if(form.find('input[name=id]').val()=='') {
        var allOptionsSelected;
      	if(form.find('.single-option-selector').length > 0) {
            allOptionsSelected = true;
            form.find('.single-option-selector').each(function(){
                if($(this).val()=="") {
                    allOptionsSelected = false;
                    return false;
                }
            });
        } else {
          	allOptionsSelected = false;
        }
      	
      	if(allOptionsSelected) {
          	var errorMsg = form.find('.validation-msg').text();
          	if(errorMsg) {
          		alert(errorMsg);
            } else {
            	alert("The selected variant is sold out.");
            }
        } else {
        	var labels = [];
            form.find('.options label').each(function(key, obj){
                labels.push($(obj).text().replace(':', '').trim());
            });
            alert("You must select a "+labels.join('/')+".");
        }
      	return false;
    }
  	return true;
}

function initSideCart() {
	$('.header .cart-wrap').click(function(e){
      e.stopPropagation();
      showSideCart(true);
      return false;
    });

    $(document).click(function(event){
      if(!$(event.target).closest('#side-cart').length && $(event.target).attr('id')!="add-cart-overlay" && $('#side-cart').hasClass('open')) {
        hideSideCart();
      }
    });

    $('body').delegate('#side-cart a.remove-from-cart', 'click', function(){
      var variantId = $(this).attr('href').replace('#', '');
      
      
      	removeItemToCart(variantId);
      
      
      return false;
    });
}

/**
 * Page-specific call-backs
 * Called after dom has loaded.
 */
var RADIANCE = {

	common : {
		init: function(){
			$('html').removeClass('no-js').addClass('js');
			setupDropdownMenus();

			$('.nav-arrow', '#top-menu').each( function(){
				$(this).css('top', Math.ceil($(this).parent(2).height()/2) + 1);
			});

		}
	},

	templateIndex : {
		init: function(){

		}
	},

	templateProduct : {
		init: function(){
			//$('#product-actions').bind( 'submit', addToCart );
			$('#thumbs li:nth-child(5n+5)').addClass('last-in-row');
		}
	},

	templateCart : {
		init: function(){
          var checkGiftNote = function() {
              if($('#chk-is-gift').is(':checked')) {
                  $('#is-gift').val('Yes');
                	$('#gift-note').show();
              } else {
                  $('#is-gift').val('No');
                  $('#gift-note').hide();
                  $('#gift-note').find('textarea').val("");
              }
          }
          $('#chk-is-gift').click(function(){
            	checkGiftNote();
          });
          checkGiftNote();
		}
	}

}

var UTIL = {

	fire : function(func,funcname, args){
		var namespace = RADIANCE;
		funcname = (funcname === undefined) ? 'init' : funcname;
		if (func !== '' && namespace[func] && typeof namespace[func][funcname] == 'function'){
			namespace[func][funcname](args);
		}
	},

	loadEvents : function(){
		var bodyId = document.body.id;

		// hit up common first.
		UTIL.fire('common');

		// do all the classes too.
		$.each(document.body.className.split(/\s+/),function(i,classnm){
			UTIL.fire(classnm);
			UTIL.fire(classnm,bodyId);
		});
	}

};
$(document).ready(UTIL.loadEvents);

/**
 * Support for dropdown menus
 */
function setupDropdownMenus(){
    $('.main-menu .has-dropdown').hoverIntent(navRollOver, navRollOut);
}

function navRollOver(e){
    $(this).find('ul:first').stop(true, true).slideDown();
}

function navRollOut(e){
    $(this).find('ul:first').stop(true, true).slideUp();
}

/**
 * Ajaxy add-to-cart
 */
function addToCart(form){
	$('#add-cart-overlay').fadeIn();
  	$.fancybox.close();
  
	$.ajax({
		type: 'POST',
		url: '/cart/add.js',
		//async: false,
		data: form.serialize(),
		dataType: 'json',
		error: addToCartFail,
		success: addToCartSuccess,
		cache: false
	});
}

function addToCartSuccess(jqXHR, textStatus, errorThrown){
	updateCartDesc();
}

function addToCartFail(jqXHR, textStatus, errorThrown){
  	var response = $.parseJSON(jqXHR.responseText);
  	$('#add-cart-overlay').fadeOut();
    var quantity = $('#product-qty').data('quantity');
    var errorMsg;

    if(response.status==422) {
        if(quantity && quantity > 0) {
          errorMsg = 'You have added more of this product than we have in stock. Please reduce the quantity and try again.';
        } else {
          errorMsg = 'You have added more of this product than we have in stock. Please reduce the quantity and try again.';
        }
    } else {
      	errorMsg = response.description;
    }

    $.fancybox('<div class="error-itemincart">'+errorMsg+'</div>', {
      padding: 0,
      margin: [40,30,20,10],
      closeEffect: 'fade',
      autoCenter: true,
      helpers: {
        overlay: { speedOut : 500 }
      }
    });
}

function removeItemToCart(variantId){
  	$('#add-cart-overlay').fadeIn();

	$('#side-cart').remove();
  	$.ajax({
		type: 'POST',
		url: '/cart/change.js',
      	data: {
          id: variantId,
          quantity: 0
        },
		dataType: 'json',
      	error: function(){
      		updateCartDesc();
          	$('#add-cart-overlay').fadeOut();
      	},
      	success: function(){
          	updateCartDesc();
      		$('#add-cart-overlay').fadeOut();
      	},
		cache: false
	});
}

function updateCartDesc(){  
  	$.ajax({
		type: 'GET',
		url: '/cart?view=side-cart',
		cache: false,
      	success: function(data){
          	$('#add-cart-overlay').fadeOut();
          
      		var animate = true;
          	if($('#side-cart').width()>0) {
              	animate = false;
            }
          	$('#side-cart').remove();
          	$('#page').append(data);
          	$.fancybox.close();
          	showSideCart(animate);
      	}
	});
}

function showSideCart(animate) {
  $('body, html').css({overflow: 'hidden'});
  $('#side-cart').addClass('open');
  $('#page').addClass('mode-overlay');
}

function hideSideCart() {
  $('#side-cart').removeClass('open');
  $('#page').removeClass('mode-overlay');
  $('body, html').css({overflow: ''});
}

function getQueryParam(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}


